import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  Checkbox,
  I18n,
  Button,
  Link,
  Preloader,
  Status,
} from 'components';
import { openErrorPopup } from 'containers/App/actions';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class TvConsoleWithActions extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      actions: this.props.actions,
      isDirty: false,
      isExpanded: false,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.actions !== this.props.actions) {
      this.setState({
        actions: props.actions,
        isDirty: false,
      });
    }
  }

  onTvConsoleClick = () => {
    this.setState((prevState) => ({ isExpanded: !prevState.isExpanded }));
    if (!this.state.actions && !this.props.isFetching) {
      this.props.fetch(this.props.guid);
    }
  };

  toggleAction = (toggledAction) => {
    this.setState((prevState) => ({
      isDirty: true,
      actions: prevState.actions
        .map((action) => (action === toggledAction ? {
          ...action,
          status: action.status === 'Active' ? 'Blocked' : 'Active',
        } : action)),
    }));
  };

  saveChanges = () => this.props.save(this.state.actions, this.props.guid);

  render() {
    const {
      guidType,
      label,
      isSaving,
      isFetching,
      fetchingError,
      savingError,
    } = this.props;
    const { actions, isExpanded, isDirty } = this.state;

    return (
      <div className={cx('tvConsole')}>
        <Link onClick={this.onTvConsoleClick}>
          {`${guidType} ${label || ''}`}
        </Link>

        {isExpanded && (
          <>
            {(!actions && isFetching) && (
              <Preloader
                className={cx('preloader')}
                size="40"
              />
            )}

            {actions && actions.map((action) => (
              <Checkbox
                key={action.notificationTypeId}
                className={cx('checkbox')}
                name={action.notificationName}
                checked={action.status === 'Active'}
                disabled={!action.canChange || isSaving}
                handleChange={() => this.toggleAction(action)}
              >
                {action.notificationName}
              </Checkbox>
            ))}

            {savingError && (
              <Status
                className={['error', cx('status')]}
                emoji="statusFail"
              >
                <I18n path="common.operationFailed" />
                {'. '}
                <Link onClick={this.saveChanges}>
                  <I18n path="common.retry" />
                </Link>
              </Status>
            )}

            {fetchingError && (
              <Status
                className={['error', cx('status')]}
                emoji="statusFail"
              >
                {fetchingError}
              </Status>
            )}

            {actions && (
              <div className={cx('actions')}>
                <Button
                  disabled={!isDirty}
                  isLoading={isSaving}
                  onClick={this.saveChanges}
                >
                  <I18n path="common.save" />
                </Button>

                {!isSaving && isDirty && (
                  <>
                    <I18n
                      className={cx('actionsDivider')}
                      path="common.or"
                    />
                    <Link
                      onClick={() => this.setState({
                        actions: this.props.actions,
                        isDirty: false,
                      })}
                    >
                      <I18n path="common.revertChanges" />
                    </Link>
                  </>
                )}
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const tvActions = state.settings.notifications.tvActions[ownProps.guid];
  return {
    actions: tvActions ? tvActions.data : null,
    isSaving: tvActions ? tvActions.isSaving : false,
    isFetching: tvActions ? tvActions.isFetching : false,
    savingError: tvActions ? tvActions.savingError : null,
    fetchingError: tvActions ? tvActions.fetchingError : null,
  };
};
const mapDispatchToProps = { openErrorPopup };

TvConsoleWithActions.propTypes = {
  guid: PropTypes.string,
  guidType: PropTypes.string,
  label: PropTypes.string,
  actions: PropTypes.array,
  save: PropTypes.func,
  fetch: PropTypes.func,
  isSaving: PropTypes.bool,
  isFetching: PropTypes.bool,
  savingError: PropTypes.string,
  fetchingError: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(TvConsoleWithActions);
